// extracted by mini-css-extract-plugin
export default {"main":"ClosableBox_main__H-4cy","nameContainer":"ClosableBox_nameContainer__vDl4D","name":"ClosableBox_name__b13q1","icon":"ClosableBox_icon__WVIaa"};